import { NgClass } from '@angular/common';
// eslint-disable-next-line @tseslint/no-shadow
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, inject, input, InputSignal, model, ModelSignal, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { IconModule } from '@ogs/ngx-m3-components';
import { ThrottleClickDirective } from "@shared/directives/throttle-click.directive";

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [ MatButtonModule, IconModule, NgClass, ThrottleClickDirective ],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {
  private _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  public isReadable: InputSignal<boolean> = input(true);

  public isDeletable: InputSignal<boolean> = input(false);

  /**
   *Model whether the notification is marked as seen by the user or not
   *
   * @emits isSeen - optimistically and doesn't wait for direct confirmation of the parent
   */
  public isSeen: ModelSignal<boolean> = model(false);

  @Output() public readonly deleteClicked: EventEmitter<void> = new EventEmitter<void>();


  constructor () {
    this._faIconLibrary.addIcons(faTrashCan);
  }

  protected onDeleteClick (): void {
    this.deleteClicked.emit();
    this.onNotificationClick();
  }

  @HostListener("click")
  protected onNotificationClick (): void {
    if (!this.isSeen())
      this.isSeen.set(true);
  }

  protected onReadClick (mouseEvent: MouseEvent): void {
    this.isSeen.set(!this.isSeen());
    mouseEvent.stopPropagation();
  }
}
